export const JPD_ROADMAP_ON_TIMELINE_SPOTLIGHT_TRIGGER =
	'jpd-roadmap-on-timeline-spotlight-trigger';
